import { useWsmProductSeriesListQuery } from "@dashboard/graphql";
import useLocalPaginator, { useLocalPaginationState } from "@dashboard/hooks/useLocalPaginator";
import { mapEdgesToItems } from "@dashboard/utils/maps";
import React, { useState } from "react";

import WsmSeriesListPage from "../components/WsmSeriesListPage/WsmSeriesListPage";
import { useWsmAxisAttributes } from "../hooks/useWsmAxisAttributes";

const PAGINATE_BY = 20;

export const WsmSeriesListView = () => {
  const [query, setQuery] = useState("");
  const [rowNumber, setRowNumber] = useState(PAGINATE_BY);
  const [paginationState, setPaginationState] = useLocalPaginationState(rowNumber);
  const paginate = useLocalPaginator(setPaginationState);
  const { data, loading } = useWsmProductSeriesListQuery({
    variables: {
      ...paginationState,
      filter: query ? { search: query } : {},
    },
  });
  // The same attribute list the detail screen ticks from: it is what turns an
  // axis slug into the name a merchant recognises.
  const { attributes } = useWsmAxisAttributes();
  const { loadNextPage, loadPreviousPage, pageInfo } = paginate(
    data?.wsmProductSeriesList?.pageInfo,
    paginationState,
  );

  return (
    <WsmSeriesListPage
      series={loading ? undefined : (mapEdgesToItems(data?.wsmProductSeriesList) ?? [])}
      attributes={attributes}
      query={query}
      rowNumber={rowNumber}
      hasNextPage={pageInfo?.hasNextPage ?? false}
      hasPreviousPage={pageInfo?.hasPreviousPage ?? false}
      onQueryChange={value => {
        setQuery(value);
        setPaginationState({});
      }}
      onRowNumberChange={value => {
        setRowNumber(value);
        setPaginationState({});
      }}
      onNextPage={loadNextPage}
      onPreviousPage={loadPreviousPage}
    />
  );
};

export default WsmSeriesListView;
